import { type EstadoCaptura } from '@fiscoai/contracts';

/** Enquanto alguma busca roda: poll curto. */
export const POLL_EXECUTANDO_MS = 3000;
/** Sem nada marcado no horizonte, o painel ainda se renova (só com a aba visível). */
export const POLL_OCIOSO_MS = 60_000;
/** Folga depois do horário marcado: o servidor precisa ter trocado a situação. */
const FOLGA_MS = 2000;
const MINIMO_MS = 5000;

/**
 * Quando o painel deve se atualizar sozinho: logo após o próximo marco conhecido (liberação da
 * SEFAZ ou próxima busca da agenda), nunca antes de 5 s nem depois de 60 s; 3 s durante uma busca.
 * O TanStack Query não roda o intervalo com a aba em segundo plano.
 */
export function intervaloAtualizacao(
  estados: readonly EstadoCaptura[],
  agora: number = Date.now(),
): number {
  if (estados.some((e) => e.situacao === 'EXECUTANDO')) return POLL_EXECUTANDO_MS;
  const marcos = estados
    .flatMap((e) => [e.liberadaEm, e.bloqueadaAte, e.proximaExecucaoEm])
    .filter((d): d is string => d !== null)
    .map((d) => Date.parse(d) - agora)
    .filter((ms) => ms > 0);
  if (marcos.length === 0) return POLL_OCIOSO_MS;
  return Math.min(POLL_OCIOSO_MS, Math.max(MINIMO_MS, Math.min(...marcos) + FOLGA_MS));
}
